var a = /* @__PURE__ */ ((e) => (e.Fr = "fr", e.Us = "us", e))(a || {}), i = /* @__PURE__ */ ((e) => (e.Sale = "sale", e.Hr = "hr", e.Ops = "ops", e.Setup = "setup", e))(i || {});
const s = [
  {
    ids: ["floriane", "flo"],
    firstName: "Floriane",
    lastName: "Guiniot",
    phoneNumber: "+33633413050",
    email: "floriane@appchoose.io",
    avatar: "floriane",
    role: [
      "sale"
      /* Sale */
    ],
    saleRegion: [
      "us"
      /* Us */
    ],
    isActive: !0
  },
  {
    ids: ["jessica"],
    firstName: "Jessica",
    lastName: "Guyomard",
    phoneNumber: "+33695398869",
    email: "jessica@appchoose.io",
    avatar: "jessica",
    role: [
      "sale"
      /* Sale */
    ],
    saleRegion: [
      "fr"
      /* Fr */
    ],
    isActive: !1
  },
  {
    ids: ["rebecca"],
    firstName: "Rébecca",
    lastName: "Cloarec",
    phoneNumber: "+33652347519",
    email: "rebecca@appchoose.io",
    avatar: "rebecca",
    role: [
      "sale"
      /* Sale */
    ],
    saleRegion: [
      "fr"
      /* Fr */
    ],
    isActive: !1
  },
  {
    ids: ["juliette.act"],
    firstName: "Juliette",
    lastName: "Aucouturier",
    phoneNumber: "+33658019979",
    email: "juliette.aucouturier@appchoose.io",
    avatar: "juliette-act",
    role: [
      "sale"
      /* Sale */
    ],
    saleRegion: [
      "fr"
      /* Fr */
    ],
    isActive: !1
  },
  {
    ids: ["alice"],
    firstName: "Alice",
    lastName: "Pelissier",
    phoneNumber: "+33660220711",
    email: "alice@appchoose.io",
    avatar: "alice",
    role: [
      "sale"
      /* Sale */
    ],
    saleRegion: [
      "fr"
      /* Fr */
    ],
    isActive: !1
  },
  {
    ids: ["isadora"],
    firstName: "Isadora",
    lastName: "Mathian",
    phoneNumber: "+33622541053",
    email: "isadora@appchoose.io",
    avatar: "isadora",
    role: [
      "sale"
      /* Sale */
    ],
    saleRegion: [
      "fr"
      /* Fr */
    ],
    isActive: !0
  },
  {
    ids: ["sarah"],
    firstName: "Sarah",
    lastName: "Gendreau",
    phoneNumber: "+33682305703",
    email: "sarah@appchoose.io",
    avatar: "sarah",
    role: [
      "sale"
      /* Sale */
    ],
    saleRegion: [
      "fr"
      /* Fr */
    ],
    isActive: !1
  },
  {
    ids: ["claire.poulain", "claire.p"],
    firstName: "Claire",
    lastName: "Poulain",
    phoneNumber: "+33785541841",
    email: "claire.poulain@appchoose.io",
    avatar: "claire",
    role: [
      "sale"
      /* Sale */
    ],
    saleRegion: [
      "us"
      /* Us */
    ],
    isActive: !0
  },
  {
    ids: ["clara"],
    firstName: "Clara",
    lastName: "Esposito",
    phoneNumber: "+33769305299",
    email: "clara@appchoose.io",
    avatar: "clara",
    role: [
      "sale"
      /* Sale */
    ],
    saleRegion: [
      "fr"
      /* Fr */
    ],
    isActive: !1
  },
  {
    ids: ["alize", "alizé"],
    firstName: "Alizé",
    lastName: "Pigné",
    phoneNumber: "+33638126186",
    email: "alize@appchoose.io",
    avatar: "alize",
    role: [
      "sale"
      /* Sale */
    ],
    saleRegion: [
      "us"
      /* Us */
    ],
    isActive: !0
  },
  {
    ids: ["alexandra"],
    firstName: "Alexandra",
    lastName: "Ceddia",
    phoneNumber: "+33658722970",
    email: "alexandra@appchoose.io",
    avatar: "alexandra",
    role: [
      "sale"
      /* Sale */
    ],
    saleRegion: [
      "fr"
      /* Fr */
    ],
    isActive: !1
  },
  {
    ids: ["juliette"],
    firstName: "Juliette",
    lastName: "Afanassieff",
    phoneNumber: "+33623485786",
    email: "juliette@appchoose.io",
    avatar: "juliette",
    role: [
      "sale"
      /* Sale */
    ],
    saleRegion: [
      "fr"
      /* Fr */
    ],
    isActive: !1
  },
  {
    ids: ["camille", "camille.s"],
    firstName: "Camille",
    lastName: "Sauvaud",
    phoneNumber: "+33686309234",
    email: "camille.s@appchoose.io",
    avatar: "camille",
    role: [
      "hr"
      /* Hr */
    ],
    saleRegion: [
      "fr"
      /* Fr */
    ],
    isActive: !1
  },
  {
    ids: ["marion", "marion ansel"],
    firstName: "Marion",
    lastName: "Ansel",
    phoneNumber: "+33609606196",
    email: "marion@appchoose.io",
    avatar: "marion",
    role: [
      "sale",
      "ops",
      "setup"
      /* Setup */
    ],
    saleRegion: [
      "fr",
      "us"
      /* Us */
    ],
    isActive: !0
  },
  {
    ids: ["hortense"],
    firstName: "Hortense",
    lastName: "Tharreau",
    phoneNumber: "+33631261212",
    email: "hortense@appchoose.io",
    avatar: "hortense",
    role: [
      "ops"
      /* Ops */
    ],
    saleRegion: [
      "fr",
      "us"
      /* Us */
    ],
    isActive: !1
  },
  {
    ids: ["anthony", "anthony.gatti"],
    firstName: "Anthony",
    lastName: "Gatti",
    phoneNumber: "+33780912793",
    email: "anthony.gatti@appchoose.io",
    avatar: "anthony",
    role: [
      "ops"
      /* Ops */
    ],
    saleRegion: [
      "fr"
      /* Fr */
    ],
    isActive: !1
  },
  {
    ids: ["lisa"],
    firstName: "Lisa",
    lastName: "Golsenne",
    phoneNumber: "+33667733388",
    email: "lisa@appchoose.io",
    avatar: "lisa",
    role: [
      "ops"
      /* Ops */
    ],
    saleRegion: [
      "fr",
      "us"
      /* Us */
    ],
    isActive: !0
  },
  {
    ids: ["margaux jullian"],
    firstName: "Margaux",
    lastName: "Jullian",
    phoneNumber: "+33664313932",
    email: "margaux@appchoose.io",
    avatar: "Margaux-Jullian",
    role: [
      "setup"
      /* Setup */
    ],
    saleRegion: [
      "fr"
      /* Fr */
    ],
    isActive: !1
  },
  {
    ids: ["mélissa imrek"],
    firstName: "Mélissa",
    lastName: "Imrek",
    phoneNumber: "+33669662860",
    email: "melissa@appchoose.io",
    avatar: "Melissa-Imrek",
    role: [
      "setup"
      /* Setup */
    ],
    saleRegion: [
      "fr"
      /* Fr */
    ],
    isActive: !1
  },
  {
    ids: ["gaëlle leroux"],
    firstName: "Gaëlle",
    lastName: "Leroux",
    phoneNumber: "+33602354557",
    email: "gaelle@appchoose.io",
    avatar: "Gaelle-Leroux",
    role: [
      "setup"
      /* Setup */
    ],
    saleRegion: [
      "fr",
      "us"
      /* Us */
    ],
    isActive: !0
  },
  {
    ids: ["léa perazio--elleon"],
    firstName: "Léa",
    lastName: "Perazio Elleon",
    phoneNumber: "",
    email: "lea@appchoose.io",
    avatar: "Lea-Perazio",
    role: [
      "setup"
      /* Setup */
    ],
    saleRegion: [
      "fr"
      /* Fr */
    ],
    isActive: !1
  },
  {
    ids: ["alexandre graulle"],
    firstName: "Alexandre",
    lastName: "Graulle",
    phoneNumber: "",
    email: "alexandre.g@appchoose.io",
    avatar: "Alexandre-Graulle",
    role: [
      "setup"
      /* Setup */
    ],
    saleRegion: [
      "fr"
      /* Fr */
    ],
    isActive: !1
  },
  {
    ids: ["angie thomas"],
    firstName: "Angie",
    lastName: "Thomas",
    phoneNumber: "+33699923918",
    email: "angie@appchoose.io",
    avatar: "Angie-Thomas",
    role: [
      "setup"
      /* Setup */
    ],
    saleRegion: [
      "fr",
      "us"
      /* Us */
    ],
    isActive: !0
  },
  {
    ids: ["thuy an le"],
    firstName: "Thuy An",
    lastName: "Le",
    phoneNumber: "+33650847690",
    email: "thuyan@appchoose.io",
    avatar: "Thuy-An-Le",
    role: [
      "setup"
      /* Setup */
    ],
    saleRegion: [
      "fr"
      /* Fr */
    ],
    isActive: !1
  },
  {
    ids: ["pauline garcin"],
    firstName: "Pauline",
    lastName: "Garcin",
    phoneNumber: "",
    email: "pauline.g@appchoose.io",
    avatar: "Pauline-Garcin",
    role: [
      "setup"
      /* Setup */
    ],
    saleRegion: [
      "fr",
      "us"
      /* Us */
    ],
    isActive: !1
  },
  {
    ids: ["charlotte"],
    firstName: "Charlotte",
    lastName: "Simonnet",
    phoneNumber: "",
    email: "charlotte@appchoose.io",
    avatar: "Charlotte-Simonnet",
    role: [
      "sale"
      /* Sale */
    ],
    saleRegion: [
      "fr"
      /* Fr */
    ],
    isActive: !1
  },
  {
    ids: ["clemence.c"],
    firstName: "Clémence",
    lastName: "Chevre",
    phoneNumber: "+33627912802",
    email: "clemence.c@appchoose.io",
    avatar: "Clemence-Chevre",
    role: [
      "sale"
      /* Sale */
    ],
    saleRegion: [
      "fr"
      /* Fr */
    ],
    isActive: !1
  },
  {
    ids: ["louis.h"],
    firstName: "Louis",
    lastName: "Heraud",
    phoneNumber: "+33760073245",
    email: "louis.h@appchoose.io",
    avatar: "Louis-Heraud",
    role: [
      "ops"
      /* Ops */
    ],
    saleRegion: [
      "fr"
      /* Fr */
    ],
    isActive: !1
  },
  {
    ids: ["gael"],
    firstName: "Gaël",
    lastName: "Treillard",
    phoneNumber: "",
    email: "gael@appchoose.io",
    avatar: "Gael-Treillard",
    role: [
      "ops"
      /* Ops */
    ],
    saleRegion: [
      "fr",
      "us"
      /* Us */
    ],
    isActive: !1
  },
  {
    ids: ["manon.l"],
    firstName: "Manon",
    lastName: "Leclercq",
    phoneNumber: "",
    email: "manon.l@appchoose.io",
    avatar: "Manon-Leclercq",
    role: [
      "sale"
      /* Sale */
    ],
    saleRegion: [
      "fr"
      /* Fr */
    ],
    isActive: !0
  },
  {
    ids: ["hsiao-anne"],
    firstName: "Hsiao-Anne",
    lastName: "Le Bot",
    phoneNumber: "",
    email: "hsiao-anne@appchoose.io",
    avatar: "HsiaoAnne-LeBot",
    role: [
      "sale"
      /* Sale */
    ],
    saleRegion: [
      "fr"
      /* Fr */
    ],
    isActive: !0
  },
  {
    ids: ["anne-stéphanie dupin"],
    firstName: "Anne-Stéphanie",
    lastName: "Dupin",
    phoneNumber: "",
    email: "anne-stephanie@appchoose.io",
    avatar: "AnneStephanie-Dupin",
    role: [
      "setup"
      /* Setup */
    ],
    saleRegion: [
      "fr",
      "us"
      /* Us */
    ],
    isActive: !0
  },
  {
    ids: ["perrine gangloff"],
    firstName: "Perrine",
    lastName: "Gangloff",
    phoneNumber: "",
    email: "perrine@appchoose.io",
    avatar: "Perrine-Gangloff",
    role: [
      "setup"
      /* Setup */
    ],
    saleRegion: [
      "fr",
      "us"
      /* Us */
    ],
    isActive: !0
  },
  {
    ids: ["calixta henrion"],
    firstName: "Calixta",
    lastName: "Henrion",
    phoneNumber: "",
    email: "calixta@appchoose.io",
    avatar: "Calixta-Henrion",
    role: [
      "setup"
      /* Setup */
    ],
    saleRegion: [
      "fr",
      "us"
      /* Us */
    ],
    isActive: !1
  },
  {
    ids: ["maura"],
    firstName: "Maura",
    lastName: "Sheedy",
    phoneNumber: "",
    email: "maura@appchoose.io",
    avatar: "Maura-Sheedy",
    role: [
      "sale"
      /* Sale */
    ],
    saleRegion: [
      "us"
      /* Us */
    ],
    isActive: !1
  },
  {
    ids: ["vincent.c"],
    firstName: "Vincent",
    lastName: "Collet",
    phoneNumber: "",
    email: "vincent.c@appchoose.io",
    avatar: "Vincent-Collet",
    role: [
      "sale"
      /* Sale */
    ],
    saleRegion: [
      "us"
      /* Us */
    ],
    isActive: !1
  },
  {
    ids: ["camille collinet"],
    firstName: "Camille",
    lastName: "Collinet",
    phoneNumber: "",
    email: "camille@appchoose.io",
    avatar: "Camille-Collinet",
    role: [
      "setup"
      /* Setup */
    ],
    saleRegion: [
      "fr"
      /* Fr */
    ],
    isActive: !1
  },
  {
    ids: ["juliette martinez"],
    firstName: "Juliette",
    lastName: "Martinez",
    phoneNumber: "",
    email: "juliette.m@appchoose.io",
    avatar: "Juliette-Martinez",
    role: [
      "setup"
      /* Setup */
    ],
    saleRegion: [
      "fr"
      /* Fr */
    ],
    isActive: !1
  },
  {
    ids: ["chloe"],
    firstName: "Chloé",
    lastName: "Huchet",
    phoneNumber: "",
    email: "chloe@appchoose.io",
    avatar: "Chloe-Huchet",
    role: [
      "sale"
      /* Sale */
    ],
    saleRegion: [
      "fr"
      /* Fr */
    ],
    isActive: !1
  },
  {
    ids: ["gabrielle bertrand"],
    firstName: "Gabrielle",
    lastName: "Bertrand",
    phoneNumber: "",
    email: "gabrielle@appchoose.io",
    avatar: "Gabrielle-Bertrand",
    role: [
      "setup"
      /* Setup */
    ],
    saleRegion: [
      "fr"
      /* Fr */
    ],
    isActive: !1
  },
  {
    ids: ["ines"],
    firstName: "Inès",
    lastName: "Latrèche",
    phoneNumber: "",
    email: "ines@appchoose.io",
    avatar: "Ines-Latreche",
    role: [
      "sale"
      /* Sale */
    ],
    saleRegion: [
      "fr"
      /* Fr */
    ],
    isActive: !1
  },
  {
    ids: ["abir"],
    firstName: "Abir",
    lastName: "Ben Thayer",
    phoneNumber: "",
    email: "abir@appchoose.io",
    avatar: "AbirBen-Thayer",
    role: [
      "ops"
      /* Ops */
    ],
    saleRegion: [
      "fr",
      "us"
      /* Us */
    ],
    isActive: !0
  },
  {
    ids: ["philippine"],
    firstName: "Philippine",
    lastName: "Leblanc",
    phoneNumber: "",
    email: "philippine@appchoose.io",
    avatar: "Philippine-Leblanc",
    role: [
      "ops"
      /* Ops */
    ],
    saleRegion: [
      "fr"
      /* Fr */
    ],
    isActive: !1
  },
  {
    ids: ["lucie.h"],
    firstName: "Lucie",
    lastName: "Heraud",
    phoneNumber: "",
    email: "lucie.h@appchoose.io",
    avatar: "Lucie-Heraud",
    role: [
      "sale"
      /* Sale */
    ],
    saleRegion: [
      "us"
      /* Us */
    ],
    isActive: !1
  },
  {
    ids: ["elisa"],
    firstName: "Elisa",
    lastName: "Richou",
    phoneNumber: "",
    email: "elisa@appchoose.io",
    avatar: "Elisa-Richou",
    role: [
      "sale"
      /* Sale */
    ],
    saleRegion: [
      "us"
      /* Us */
    ],
    isActive: !1
  },
  {
    ids: ["romane decrept"],
    firstName: "Romane",
    lastName: "Decrept",
    phoneNumber: "",
    email: "romane@appchoose.io",
    avatar: "Romane-Decrept",
    role: [
      "setup"
      /* Setup */
    ],
    saleRegion: [
      "fr"
      /* Fr */
    ],
    isActive: !1
  },
  {
    ids: ["claire"],
    firstName: "Claire",
    lastName: "Colling",
    phoneNumber: "0660428006",
    email: "claire@appchoose.io",
    avatar: "Claire-Colling",
    role: [
      "sale"
      /* Sale */
    ],
    saleRegion: [
      "fr"
      /* Fr */
    ],
    isActive: !1
  },
  {
    ids: ["pierre"],
    firstName: "Pierre",
    lastName: "Chereau",
    phoneNumber: "",
    email: "pierre@appchoose.io",
    avatar: "Pierre-Chereau",
    role: [
      "ops"
      /* Ops */
    ],
    saleRegion: [
      "fr",
      "us"
      /* Us */
    ],
    isActive: !0
  },
  {
    ids: ["julia"],
    firstName: "Julia",
    lastName: "Gauthier",
    phoneNumber: "",
    email: "julia@appchoose.io",
    avatar: "Julia-Gauthier",
    role: [
      "sale"
      /* Sale */
    ],
    saleRegion: [
      "fr"
      /* Fr */
    ],
    isActive: !1
  },
  {
    ids: ["mina belasri"],
    firstName: "Mina",
    lastName: "Belasri",
    phoneNumber: "",
    email: "mina@appchoose.io",
    avatar: "Mina-Belasri",
    role: [
      "setup"
      /* Setup */
    ],
    saleRegion: [
      "fr",
      "us"
      /* Us */
    ],
    isActive: !0
  },
  {
    ids: ["jordan kreindler"],
    firstName: "Jordan",
    lastName: "Kreindler",
    phoneNumber: "",
    email: "jordan.kreindler@appchoose.io",
    avatar: "Jordan-Kreindler",
    role: [
      "setup"
      /* Setup */
    ],
    saleRegion: [
      "us"
      /* Us */
    ],
    isActive: !1
  },
  {
    ids: ["clémence bouras"],
    firstName: "Clémence",
    lastName: "Bouras",
    phoneNumber: "",
    email: "clemence.b@appchoose.io",
    avatar: "Clemence-Bouras",
    role: [
      "setup"
      /* Setup */
    ],
    saleRegion: [
      "us"
      /* Us */
    ],
    isActive: !1
  },
  {
    ids: ["philippine.g"],
    firstName: "Philippine",
    lastName: "Gonord",
    phoneNumber: "",
    email: "philippine.g@appchoose.io",
    avatar: "Philippine-Gonord",
    role: [
      "ops"
      /* Ops */
    ],
    saleRegion: [
      "fr",
      "us"
      /* Us */
    ],
    isActive: !1
  },
  {
    ids: ["camille villers"],
    firstName: "Camille",
    lastName: "Villers",
    phoneNumber: "",
    email: "camille.v@appchoose.io",
    avatar: "Camille-Villers",
    role: [
      "setup"
      /* Setup */
    ],
    saleRegion: [
      "fr"
      /* Fr */
    ],
    isActive: !1
  },
  {
    ids: ["marie mateuf"],
    firstName: "Marie",
    lastName: "Mateuf",
    phoneNumber: "",
    email: "marie.m@appchoose.io",
    avatar: "Marie-Mateuf",
    role: [
      "setup"
      /* Setup */
    ],
    saleRegion: [
      "fr",
      "us"
      /* Us */
    ],
    isActive: !1
  },
  {
    ids: ["nicole mathai"],
    firstName: "Nicole",
    lastName: "Mathai",
    phoneNumber: "",
    email: "nicole@appchoose.io",
    avatar: "Nicole-Mathai",
    role: [
      "setup"
      /* Setup */
    ],
    saleRegion: [
      "us"
      /* Us */
    ],
    isActive: !1
  },
  {
    ids: ["maeva"],
    firstName: "Maeva",
    lastName: "Renaudin",
    phoneNumber: "",
    email: "maeva@appchoose.io",
    avatar: "Maeva-Renaudin",
    role: [
      "sale"
      /* Sale */
    ],
    saleRegion: [
      "us"
      /* Us */
    ],
    isActive: !0
  },
  {
    ids: ["isabel"],
    firstName: "Isabel",
    lastName: "Montalvan",
    phoneNumber: "",
    email: "isabel@appchoose.io",
    avatar: "Isabel-Montalvan",
    role: [
      "sale"
      /* Sale */
    ],
    saleRegion: [
      "us"
      /* Us */
    ],
    isActive: !0
  },
  {
    ids: ["pierre brusco"],
    firstName: "Pierre",
    lastName: "Brusco",
    phoneNumber: "",
    email: "pierre.b@appchoose.io",
    avatar: "Pierre-Brusco",
    role: [
      "setup"
      /* Setup */
    ],
    saleRegion: [
      "fr",
      "us"
      /* Us */
    ],
    isActive: !1
  },
  {
    ids: ["su htoo mon"],
    firstName: "Su",
    lastName: "Htoo Mon",
    phoneNumber: "",
    email: "su@appchoose.io",
    avatar: "Su-Htoo-Mon",
    role: [
      "setup"
      /* Setup */
    ],
    saleRegion: [
      "us"
      /* Us */
    ],
    isActive: !1
  },
  {
    ids: ["charlotte brajou"],
    firstName: "Charlotte",
    lastName: "Brajou",
    phoneNumber: "",
    email: "charlotte.brajou@appchoose.io",
    avatar: "Charlotte-Brajou",
    role: [
      "setup"
      /* Setup */
    ],
    saleRegion: [
      "fr",
      "us"
      /* Us */
    ],
    isActive: !1
  },
  {
    ids: ["charlotte.ollitrault"],
    firstName: "Charlotte",
    lastName: "Ollitrault",
    phoneNumber: "",
    email: "charlotte.ollitrault@appchoose.io",
    avatar: "Charlotte-Ollitrault",
    role: [
      "sale"
      /* Sale */
    ],
    saleRegion: [
      "us"
      /* Us */
    ],
    isActive: !1
  },
  {
    ids: ["andrea.m"],
    firstName: "Andréa",
    lastName: "Mercadié",
    phoneNumber: "",
    email: "andrea.m@appchoose.io",
    avatar: "Andrea-Mercadie",
    role: [
      "ops"
      /* Ops */
    ],
    saleRegion: [
      "fr",
      "us"
      /* Us */
    ],
    isActive: !1
  },
  {
    ids: ["anne-claire.b"],
    firstName: "Anne-Claire",
    lastName: "Barthelemy",
    phoneNumber: "",
    email: "anne-claire.b@appchoose.io",
    avatar: "Anne-Claire-Barthelemy",
    role: [
      "sale"
      /* Sale */
    ],
    saleRegion: [
      "fr"
      /* Fr */
    ],
    isActive: !0
  },
  {
    ids: ["apolline.g"],
    firstName: "Apolline",
    lastName: "Gibon",
    phoneNumber: "",
    email: "apolline.g@appchoose.io",
    avatar: "Apolline-Gibon",
    role: [
      "sale"
      /* Sale */
    ],
    saleRegion: [
      "fr"
      /* Fr */
    ],
    isActive: !0
  },
  {
    ids: ["charlotte.bigotte", "charlotte.b"],
    firstName: "Charlotte",
    lastName: "Bigotte",
    phoneNumber: "",
    email: "charlotte.bigotte@appchoose.io",
    avatar: "Charlotte-Bigotte",
    role: [
      "sale"
      /* Sale */
    ],
    saleRegion: [
      "fr"
      /* Fr */
    ],
    isActive: !1
  },
  {
    ids: ["mathilde.u"],
    firstName: "Mathilde",
    lastName: "Uhlhorn",
    phoneNumber: "",
    email: "mathilde.u@appchoose.io",
    avatar: "Mathilde-Uhlhorn",
    role: [
      "ops"
      /* Ops */
    ],
    saleRegion: [
      "fr",
      "us"
      /* Us */
    ],
    isActive: !0
  },
  {
    ids: ["lucie noblanc"],
    firstName: "Lucie",
    lastName: "Noblanc",
    phoneNumber: "",
    email: "lucie.noblanc@appchoose.io",
    avatar: "Lucie-Noblanc",
    role: [
      "setup"
      /* Setup */
    ],
    saleRegion: [
      "fr",
      "us"
      /* Us */
    ],
    isActive: !0
  },
  {
    ids: ["noemie.b"],
    firstName: "Noémie",
    lastName: "Babinot",
    phoneNumber: "",
    email: "noemie.b@appchoose.io",
    avatar: "Noemie-Babinot",
    role: [
      "sale"
      /* Sale */
    ],
    saleRegion: [
      "us"
      /* Us */
    ],
    isActive: !1
  },
  {
    ids: ["capucine.d"],
    firstName: "Capucine",
    lastName: "Dumans",
    phoneNumber: "",
    email: "capucine.d@appchoose.io",
    avatar: "Capucine-Dumans",
    role: [
      "sale"
      /* Sale */
    ],
    saleRegion: [
      "fr"
      /* Fr */
    ],
    isActive: !0
  },
  {
    ids: ["midori.harvey"],
    firstName: "Midori",
    lastName: "Harvey",
    phoneNumber: "",
    email: "midori.harvey@appchoose.io",
    avatar: "Midori-Harvey",
    role: [
      "sale"
      /* Sale */
    ],
    saleRegion: [
      "us"
      /* Us */
    ],
    isActive: !1
  },
  {
    ids: ["taylor.brohrer"],
    firstName: "Taylor",
    lastName: "Brohrer",
    phoneNumber: "",
    email: "taylor@appchoose.io",
    avatar: "Taylor-Brohrer",
    role: [
      "sale"
      /* Sale */
    ],
    saleRegion: [
      "us"
      /* Us */
    ],
    isActive: !1
  },
  {
    ids: ["lea.s"],
    firstName: "Léa",
    lastName: "Sellenet",
    phoneNumber: "",
    email: "lea.sellenet@appchoose.io",
    avatar: "Lea-Sellenet",
    role: [
      "ops"
      /* Ops */
    ],
    saleRegion: [
      "fr",
      "us"
      /* Us */
    ],
    isActive: !1
  },
  {
    ids: ["clemence.cavelier"],
    firstName: "Clémence",
    lastName: "Cavelier",
    phoneNumber: "",
    email: "clemence.c@appchoose.io",
    avatar: "Clemence-Cavelier",
    role: [
      "sale"
      /* Sale */
    ],
    saleRegion: [
      "fr"
      /* Fr */
    ],
    isActive: !0
  },
  {
    ids: ["clara-lou"],
    firstName: "Clara-Lou",
    lastName: "Da Fonseca",
    phoneNumber: "",
    email: "clara-lou@appchoose.io",
    avatar: "ClaraLou-DaFonsecaCoelho",
    role: [
      "sale"
      /* Sale */
    ],
    saleRegion: [
      "us"
      /* Us */
    ],
    isActive: !0
  },
  {
    ids: ["mathilde.r"],
    firstName: "Mathilde",
    lastName: "Ramalho",
    phoneNumber: "",
    email: "mathilde.r@appchoose.io",
    avatar: "Mathilde-Ramalho",
    role: [
      "sale"
      /* Sale */
    ],
    saleRegion: [
      "us"
      /* Us */
    ],
    isActive: !0
  },
  {
    ids: ["ximena chilet buitrón"],
    firstName: "Ximena",
    lastName: "Chilet Buitrón",
    phoneNumber: "",
    email: "ximena@appchoose.io",
    avatar: "Ximena-Chilet",
    role: [
      "setup"
      /* Setup */
    ],
    saleRegion: [
      "fr",
      "us"
      /* Us */
    ],
    isActive: !0
  },
  {
    ids: ["magali velasco"],
    firstName: "Magali",
    lastName: "Velasco",
    phoneNumber: "",
    email: "magali.v@appchoose.io",
    avatar: "Magali-Velasco",
    role: [
      "setup"
      /* Setup */
    ],
    saleRegion: [
      "fr",
      "us"
      /* Us */
    ],
    isActive: !1
  },
  {
    ids: ["annelise.quelard"],
    firstName: "Anne-Lise",
    lastName: "Quelard",
    phoneNumber: "",
    email: "annelise.quelard@appchoose.io",
    avatar: "AnneLise-Quelard",
    role: [
      "ops"
      /* Ops */
    ],
    saleRegion: [
      "fr",
      "us"
      /* Us */
    ],
    isActive: !1
  },
  {
    ids: ["alexandre.bellot"],
    firstName: "Alexandre",
    lastName: "Bellot",
    phoneNumber: "",
    email: "alexandre.bellot@appchoose.io",
    avatar: "Alexandre-Bellot",
    role: [
      "ops"
      /* Ops */
    ],
    saleRegion: [
      "fr",
      "us"
      /* Us */
    ],
    isActive: !0
  },
  {
    ids: ["jade.d"],
    firstName: "Jade",
    lastName: "Devoucoux",
    phoneNumber: "",
    email: "jade.d@appchoose.io",
    avatar: "Jade-Devoucoux",
    role: [
      "sale"
      /* Sale */
    ],
    saleRegion: [
      "us"
      /* Us */
    ],
    isActive: !1
  },
  {
    ids: ["alizee.aventurier"],
    firstName: "Alizée",
    lastName: "Aventurier",
    phoneNumber: "",
    email: "alizee.aventurier@appchoose.io",
    avatar: "Alizee-Aventurier",
    role: [
      "sale"
      /* Sale */
    ],
    saleRegion: [
      "fr"
      /* Fr */
    ],
    isActive: !1
  },
  {
    ids: ["pauline.vivier"],
    firstName: "Pauline",
    lastName: "Vivier",
    phoneNumber: "",
    email: "pauline.vivier@appchoose.io",
    avatar: "Pauline-Vivier",
    role: [
      "sale"
      /* Sale */
    ],
    saleRegion: [
      "fr"
      /* Fr */
    ],
    isActive: !0
  },
  {
    ids: ["justine.hueber"],
    firstName: "Justine",
    lastName: "Hueber",
    phoneNumber: "",
    email: "justine.hueber@appchoose.io",
    avatar: "Justine-Hueber",
    role: [
      "sale"
      /* Sale */
    ],
    saleRegion: [
      "fr"
      /* Fr */
    ],
    isActive: !0
  },
  {
    ids: ["jonas.texier"],
    firstName: "Jonas",
    lastName: "Texier",
    phoneNumber: "",
    email: "jonas.texier@appchoose.io",
    avatar: "Jonas-Texier",
    role: [
      "sale"
      /* Sale */
    ],
    saleRegion: [
      "fr"
      /* Fr */
    ],
    isActive: !1
  },
  {
    ids: ["ambre dumont sautter"],
    firstName: "Ambre",
    lastName: "Dumont Sautter",
    phoneNumber: "",
    email: "ambre.dumont-sautter@appchoose.io",
    avatar: "Ambre-Dumont-Sautter",
    role: [
      "setup"
      /* Setup */
    ],
    saleRegion: [
      "fr",
      "us"
      /* Us */
    ],
    isActive: !1
  },
  {
    ids: ["morgane micheau"],
    firstName: "Morgane",
    lastName: "Micheau",
    phoneNumber: "",
    email: "morgane.micheau@appchoose.io",
    avatar: "Morgane-Micheau",
    role: [
      "setup"
      /* Setup */
    ],
    saleRegion: [
      "fr",
      "us"
      /* Us */
    ],
    isActive: !0
  },
  {
    ids: ["isham.dramsy"],
    firstName: "Isham",
    lastName: "Dramsy",
    phoneNumber: "",
    email: "isham@appchoose.io",
    avatar: "Isham-Dramsy",
    role: [
      "sale"
      /* Sale */
    ],
    saleRegion: [
      "fr"
      /* Fr */
    ],
    isActive: !0
  },
  {
    ids: ["emma.gautier"],
    firstName: "Emma",
    lastName: "Gautier",
    phoneNumber: "",
    email: "emma.gautier@appchoose.io",
    avatar: "Emma-Gautier",
    role: [
      "sale"
      /* Sale */
    ],
    saleRegion: [
      "us"
      /* Us */
    ],
    isActive: !0
  },
  {
    ids: ["ahmed.zinelabidine"],
    firstName: "Ahmed",
    lastName: "Zinelabidine",
    phoneNumber: "",
    email: "ahmed.zinelabidine@appchoose.io",
    avatar: "Ahmed-Zinelabidine",
    role: [
      "ops"
      /* Ops */
    ],
    saleRegion: [
      "fr",
      "us"
      /* Us */
    ],
    isActive: !1
  },
  {
    ids: ["lea.simonin"],
    firstName: "Léa",
    lastName: "Simonin",
    phoneNumber: "",
    email: "lea.simonin@appchoose.io",
    avatar: "Lea-Simonin",
    role: [
      "sale"
      /* Sale */
    ],
    saleRegion: [
      "fr"
      /* Fr */
    ],
    isActive: !0
  },
  {
    ids: ["aurelia.cuny-hubert"],
    firstName: "Aurélia",
    lastName: "Cuny-Hubert",
    phoneNumber: "",
    email: "aurelia.cuny-hubert@appchoose.io",
    avatar: "Aurelia-CunyHubert",
    role: [
      "sale"
      /* Sale */
    ],
    saleRegion: [
      "fr"
      /* Fr */
    ],
    isActive: !1
  },
  {
    ids: ["theo.delefortrie"],
    firstName: "Théo",
    lastName: "Delefortrie",
    phoneNumber: "",
    email: "theo.delefortrie@appchoose.io",
    avatar: "Theo-Delefortrie",
    role: [
      "ops"
      /* Ops */
    ],
    saleRegion: [
      "fr",
      "us"
      /* Us */
    ],
    isActive: !0
  },
  {
    ids: ["stefania.dupont"],
    firstName: "Stefania",
    lastName: "Dupont",
    phoneNumber: "",
    email: "stefania.dupont@appchoose.io",
    avatar: "Stefania-Dupont",
    role: [
      "sale"
      /* Sale */
    ],
    saleRegion: [
      "fr"
      /* Fr */
    ],
    isActive: !0
  },
  {
    ids: ["leyla.paolucci"],
    firstName: "Leyla",
    lastName: "Paolucci",
    phoneNumber: "",
    email: "leyla.paolucci@appchoose.io",
    avatar: "Leyla-Paolucci",
    role: [
      "sale"
      /* Sale */
    ],
    saleRegion: [
      "fr"
      /* Fr */
    ],
    isActive: !0
  },
  {
    ids: ["ilana.bismuth"],
    firstName: "Ilana",
    lastName: "Bismuth",
    phoneNumber: "",
    email: "ilana.bismuth@appchoose.io",
    avatar: "Ilana-Bismuth",
    role: [
      "sale"
      /* Sale */
    ],
    saleRegion: [
      "fr"
      /* Fr */
    ],
    isActive: !0
  },
  {
    ids: ["lou.foucher"],
    firstName: "Lou",
    lastName: "Foucher",
    phoneNumber: "",
    email: "lou.foucher@appchoose.io",
    avatar: "Lou-Foucher",
    role: [
      "sale"
      /* Sale */
    ],
    saleRegion: [
      "fr"
      /* Fr */
    ],
    isActive: !0
  },
  {
    ids: ["jane.guilloteau"],
    firstName: "Jane",
    lastName: "Guilloteau",
    phoneNumber: "",
    email: "jane.guilloteau@appchoose.io",
    avatar: "Jane-Guilloteau",
    role: [
      "sale"
      /* Sale */
    ],
    saleRegion: [
      "fr"
      /* Fr */
    ],
    isActive: !0
  },
  {
    ids: ["emma.benaud"],
    firstName: "Emma",
    lastName: "Benaud",
    phoneNumber: "",
    email: "emma.benaud@appchoose.io",
    avatar: "Emma-Benaud",
    role: [
      "sale"
      /* Sale */
    ],
    saleRegion: [
      "fr"
      /* Fr */
    ],
    isActive: !0
  },
  {
    ids: ["hamza.dardiz"],
    firstName: "Hamza",
    lastName: "Dardiz",
    phoneNumber: "",
    email: "hamza.dardiz@appchoose.io",
    avatar: "Hamza-Dardiz",
    role: [
      "ops"
      /* Ops */
    ],
    saleRegion: [
      "fr"
      /* Fr */
    ],
    isActive: !0
  },
  {
    ids: ["polina gusarova"],
    firstName: "Polina",
    lastName: "Gusarova",
    phoneNumber: "",
    email: "polina@appchoose.io",
    avatar: "Polina-Gusarova",
    role: [
      "setup"
      /* Setup */
    ],
    saleRegion: [
      "fr"
      /* Fr */
    ],
    isActive: !1
  },
  {
    ids: ["virginie graux"],
    firstName: "Virginie",
    lastName: "Graux",
    phoneNumber: "",
    email: "virginie.graux@appchoose.io",
    avatar: "Virginie-Graux",
    role: [
      "setup"
      /* Setup */
    ],
    saleRegion: [
      "fr",
      "us"
      /* Us */
    ],
    isActive: !0
  },
  {
    ids: ["lucile.motet-fevre"],
    firstName: "Lucile",
    lastName: "Motet-Fèvre",
    phoneNumber: "",
    email: "lucile.motet-fevre@appchoose.io",
    avatar: "Lucile-Motet-Fevre",
    role: [
      "sale"
      /* Sale */
    ],
    saleRegion: [
      "fr"
      /* Fr */
    ],
    isActive: !0
  },
  {
    ids: ["cleo.pacher"],
    firstName: "Cléo",
    lastName: "Pacher",
    phoneNumber: "",
    email: "cleo.pacher@appchoose.io",
    avatar: "Cleo-Pacher",
    role: [
      "sale"
      /* Sale */
    ],
    saleRegion: [
      "fr"
      /* Fr */
    ],
    isActive: !0
  },
  {
    ids: ["romain.lanciers"],
    firstName: "Romain",
    lastName: "Lanciers",
    phoneNumber: "",
    email: "romain.lanciers@appchoose.io",
    avatar: "Romain-Lanciers",
    role: [
      "sale"
      /* Sale */
    ],
    saleRegion: [
      "fr"
      /* Fr */
    ],
    isActive: !0
  },
  {
    ids: ["philippine.deraucourt"],
    firstName: "Philippine",
    lastName: "de Raucourt",
    phoneNumber: "",
    email: "philippine.deraucourt@appchoose.io",
    avatar: "Philippine-de-Raucourt",
    role: [
      "sale"
      /* Sale */
    ],
    saleRegion: [
      "fr"
      /* Fr */
    ],
    isActive: !0
  },
  {
    ids: ["ophelie.grolleau"],
    firstName: "Ophélie",
    lastName: "Grolleau",
    phoneNumber: "",
    email: "ophelie.grolleau@appchoose.io",
    avatar: "Ophelie-Grolleau",
    role: [
      "sale"
      /* Sale */
    ],
    saleRegion: [
      "fr"
      /* Fr */
    ],
    isActive: !0
  },
  {
    ids: ["charlotte.coatanea"],
    firstName: "Charlotte",
    lastName: "Coatanea",
    phoneNumber: "",
    email: "charlotte.coatanea@appchoose.io",
    avatar: "Charlotte-Coatanea",
    role: [
      "sale"
      /* Sale */
    ],
    saleRegion: [
      "fr"
      /* Fr */
    ],
    isActive: !0
  },
  {
    ids: ["oscar.chognon"],
    firstName: "Oscar",
    lastName: "Chognon",
    phoneNumber: "",
    email: "oscar.chognon@appchoose.io",
    avatar: "Oscar-Chognon",
    role: [
      "sale"
      /* Sale */
    ],
    saleRegion: [
      "fr"
      /* Fr */
    ],
    isActive: !0
  },
  {
    ids: ["arthur.galliand"],
    firstName: "Arthur",
    lastName: "Galliand",
    phoneNumber: "",
    email: "arthur.galliand@appchoose.io",
    avatar: "Arthur-Galliand",
    role: [
      "sale"
      /* Sale */
    ],
    saleRegion: [
      "fr"
      /* Fr */
    ],
    isActive: !0
  },
  {
    ids: ["louisa.corcellut"],
    firstName: "Louisa",
    lastName: "Corcellut",
    phoneNumber: "",
    email: "louisa.corcellut@appchoose.io",
    avatar: "Louisa-Corcellut",
    role: [
      "sale"
      /* Sale */
    ],
    saleRegion: [
      "fr"
      /* Fr */
    ],
    isActive: !0
  },
  {
    ids: ["salome.raynaud"],
    firstName: "Salomé",
    lastName: "Raynaud",
    phoneNumber: "",
    email: "salome.raynaud@appchoose.io",
    avatar: "Salome-Raynaud",
    role: [
      "sale"
      /* Sale */
    ],
    saleRegion: [
      "fr",
      "us"
      /* Us */
    ],
    isActive: !0
  },
  {
    ids: ["blandine.delacroix"],
    firstName: "Blandine",
    lastName: "Delacroix",
    phoneNumber: "",
    email: "blandine.delacroix@appchoose.io",
    avatar: "Blandine-Delacroix",
    role: [
      "sale"
      /* Sale */
    ],
    saleRegion: [
      "us"
      /* Us */
    ],
    isActive: !0
  },
  {
    ids: ["agathe.clement"],
    firstName: "Agathe",
    lastName: "Clément",
    phoneNumber: "",
    email: "agathe.clement@appchoose.io",
    avatar: "Agathe-Clement",
    role: [
      "ops"
      /* Ops */
    ],
    saleRegion: [
      "fr"
      /* Fr */
    ],
    isActive: !0
  },
  {
    ids: ["marie bony"],
    firstName: "Marie",
    lastName: "Bony",
    phoneNumber: "",
    email: "marie.bony@appchoose.io",
    avatar: "Marie-Bony",
    role: [
      "setup"
      /* Setup */
    ],
    saleRegion: [
      "fr",
      "us"
      /* Us */
    ],
    isActive: !0
  },
  {
    ids: ["elody chean"],
    firstName: "Elody",
    lastName: "Chean",
    phoneNumber: "",
    email: "elody.chean@appchoose.io",
    avatar: "Elody-Chean",
    role: [
      "setup"
      /* Setup */
    ],
    saleRegion: [
      "fr",
      "us"
      /* Us */
    ],
    isActive: !0
  },
  {
    ids: ["aoife dowling"],
    firstName: "Aoife",
    lastName: "Dowling",
    phoneNumber: "",
    email: "aoife.dowling@appchoose.io",
    avatar: "Aoife-Dowling",
    role: [
      "setup"
      /* Setup */
    ],
    saleRegion: [
      "fr",
      "us"
      /* Us */
    ],
    isActive: !0
  },
  {
    ids: ["orane.ascencio"],
    firstName: "Orane",
    lastName: "Ascencio",
    phoneNumber: "",
    email: "orane.ascencio@appchoose.io",
    avatar: "Orane-Ascencio",
    role: [
      "ops"
      /* Ops */
    ],
    saleRegion: [
      "fr",
      "us"
      /* Us */
    ],
    isActive: !0
  },
  {
    ids: ["juliette renard"],
    firstName: "Juliette",
    lastName: "Renard",
    phoneNumber: "",
    email: "juliette.renard@appchoose.io",
    avatar: "Juliette-Renard",
    role: [
      "setup"
      /* Setup */
    ],
    saleRegion: [
      "fr",
      "us"
      /* Us */
    ],
    isActive: !0
  },
  {
    ids: ["jeanne.fabre"],
    firstName: "Jeanne",
    lastName: "Fabre",
    phoneNumber: "",
    email: "jeanne.fabre@appchoose.io",
    avatar: "Jeanne-Fabre",
    role: [
      "sale"
      /* Sale */
    ],
    saleRegion: [
      "fr"
      /* Fr */
    ],
    isActive: !0
  },
  {
    ids: ["odile martin"],
    firstName: "Odile",
    lastName: "Martin",
    phoneNumber: "",
    email: "odile.martin@appchoose.io",
    avatar: "Odile-Martin",
    role: [
      "setup"
      /* Setup */
    ],
    saleRegion: [
      "fr",
      "us"
      /* Us */
    ],
    isActive: !0
  },
  {
    ids: ["sarah.durand"],
    firstName: "Sarah",
    lastName: "Durand",
    phoneNumber: "",
    email: "sarah.durand@appchoose.io",
    avatar: "Sarah-Durand",
    role: [
      "sale"
      /* Sale */
    ],
    saleRegion: [
      "us"
      /* Us */
    ],
    isActive: !0
  },
  {
    ids: ["doua.cissokho"],
    firstName: "Doua",
    lastName: "Cissokho",
    phoneNumber: "",
    email: "doua.cissokho@appchoose.io",
    avatar: "",
    role: [
      "sale"
      /* Sale */
    ],
    saleRegion: [
      "fr"
      /* Fr */
    ],
    isActive: !0
  },
  {
    ids: ["jeanne henrion"],
    firstName: "Jeanne",
    lastName: "Henrion",
    phoneNumber: "",
    email: "jeanne.henrion@appchoose.io",
    avatar: "Jeanne-Henrion",
    role: [
      "setup"
      /* Setup */
    ],
    saleRegion: [
      "fr",
      "us"
      /* Us */
    ],
    isActive: !0
  },
  {
    ids: ["margaux mazauric"],
    firstName: "Margaux",
    lastName: "Mazauric",
    phoneNumber: "",
    email: "margaux.mazauric@appchoose.io",
    avatar: "Margaux-Mazauric",
    role: [
      "setup"
      /* Setup */
    ],
    saleRegion: [
      "fr",
      "us"
      /* Us */
    ],
    isActive: !0
  },
  {
    ids: ["romane deschamps"],
    firstName: "Romane",
    lastName: "Deschamps",
    phoneNumber: "",
    email: "romane.deschamps@appchoose.io",
    avatar: "Romane-Deschamps",
    role: [
      "setup"
      /* Setup */
    ],
    saleRegion: [
      "fr",
      "us"
      /* Us */
    ],
    isActive: !0
  }
];
export {
  i as ContactRole,
  a as StoreRegion,
  s as contacts
};
